'use strict';

var processInclude = require('./components/processInclude');

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./login/loginModal'));
});
